"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disabledSelector = disabledSelector;
exports.errorSelector = errorSelector;
exports.hasErrorSelector = hasErrorSelector;
var _social = require("../../types/social");
function disabledSelector(state) {
  const {
    social: {
      authenticate: {
        status: authenticateStatus
      },
      create: {
        status: createStatus
      }
    }
  } = state;
  return authenticateStatus === _social.EAuthenticateStatus.Loading || createStatus === _social.ECreateStatus.Loading;
}
function hasErrorSelector(state) {
  const {
    social: {
      authenticate: {
        status: authenticateStatus
      },
      create: {
        status: createStatus
      }
    }
  } = state;
  return createStatus === _social.ECreateStatus.Failed || authenticateStatus === _social.EAuthenticateStatus.Failed && createStatus === _social.ECreateStatus.Succeed;
}
function errorSelector(state) {
  if (!hasErrorSelector(state)) {
    return undefined;
  }
  const {
    social: {
      authenticate: {
        error: authenticateError
      },
      create: {
        status: createStatus,
        error: createError
      }
    }
  } = state;
  return createStatus === _social.ECreateStatus.Failed ? createError : authenticateError;
}